module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm_04"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 1997 by Cécile de La Baume")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("English translation copyright © 1997 Grove Atlantic")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("French copyright © 1996 Éditions Grasset & Fasquelle")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Originally published in France by Éditions Grasset & Fasquelle under the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Béguin.")]), _vm._v(" The author wishes to express special thanks to Tatiana de Rosnay.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Published simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('span', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("La Baume, Cécile de, 1960–")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("Crush: an erotic novel / Cécile de La Baume; translated from the French by Ramona Desfleurs")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("ISBN 978-0-8021-3595-7 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("eISBN 978-0-8021-9319-3")]), _vm._v(" "), _c('p', {
    staticClass: "copy4"
  }, [_vm._v("I. Desfleurs, Ramona. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("PQ2672.A162174B4413      1997")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("843’.914—dc21"), _c('span', {
    staticClass: "indtxt1"
  }, [_vm._v("97-21266")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Designed by Laura Hammond Hough")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Cover design by Wendy Halitzer")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Cover photograph by Robert Farber")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("an imprint of Grove Atlantic")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("154 West 14th Street")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710f8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 72
// module chunks = 0